{
  "search.page.description": "Tüm çalışma alanlarındaki hesap kayıtlarını bul ve kanonik kaynağı aç.",
  "search.page.emptyDescription": "Bir kelime veya ifade gir; filtreler isteğe bağlıdır.",
  "search.page.emptyTitle": "Kayıtlarında ara",
  "search.page.error": "Arama sonuçları yüklenemedi",
  "search.page.filterKinds": "Kayıt türleri",
  "search.page.loadMore": "Daha fazla sonuç yükle",
  "search.page.noResults": "Eşleşen kayıt yok",
  "search.page.noResultsHint": "Daha az filtre veya farklı bir ifade dene.",
  "search.page.query": "Arama ifadesi",
  "search.page.resultCount_one": "1 sonuç",
  "search.page.resultCount_other": "{{count}} sonuç",
  "search.page.submit": "Ara",
  "search.page.title": "Arama",
  "search.kind.intakeProposal": "Alım önerisi",
  "search.kind.journalEntry": "Günlük kaydı",
  "search.kind.lifeView": "Yaşam görünümü",
  "search.kind.memoryCollection": "Hafıza koleksiyonu",
  "search.kind.metricDefinition": "Gösterge tanımı",
  "search.kind.planDeviation": "Plan sapması",
  "search.kind.rationale": "Gerekçe",
  "search.kind.ruleDefinition": "Kural tanımı",
  "search.kind.scheduleBlock": "Takvim bloğu",
  "search.kind.supportSession": "Destek oturumu",
  "search.kind.workSession": "Çalışma oturumu"
}
